import styles from 'components/cases/common/Interview/Interview.module.scss'
import TitleFlex from 'components/cases/common/TitleFlex'
import { useEffect, useRef } from 'react'
import { gsap, Power4 } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import { ContentData } from 'components/cases/common/Interview/fragments/type'
import InterviewContents from 'components/cases/common/Interview/InterviewContents'
gsap.registerPlugin(ScrollTrigger)

const contentData: ContentData[][] = [
  [
    {
      type: 'sectionTitle',
      text: 'Aitriaを選んだ決め手は「コミュニケーションのしやすさ」「柔軟性」',
    },
    {
      type: 'imageWithCaption',
      src: '/images/img/cases/kaiho/interview1.webp',
      alt: 'インタビュー写真',
      text: '左から、会宝産業株式会社の常務取締役・櫻井茂宏さん、海外事業部・朝倉真珠美さん',
    },
    {
      type: 'textBox',
      texts: ['―― 本プロジェクトのパートナー企業として、Aitriaにご依頼いただいた理由を教えていただけますか？'],
      wide: false,
      bold: true,
    },
    {
      type: 'greyBox',
      name: '鈴木さん',
      texts: [
        '約3社と比較検討してAitriaさんにお願いすることにしました。もちろん費用面などの諸条件もポイントでしたが、いちばん大きな理由は「コミュニケーションのしやすさ」です。というのも、私たちの業界は非常に複雑かつ特殊で、さらに今回は世の中に存在しないECサイトを作るというプロジェクトであるため、要件定義に相当な時間がかかることが予想されていたからです。',
        'そこで今回はパートナー選びにあたり「自分たちのビジネスを理解いただき、我々の思いを汲み取ってくれること」を重要視しました。そこには、Aitriaの代表である芝さんが、私たちの業界に関する知識をお持ちだというのもポイントとなりました。',
      ],
    },
    {
      type: 'greyBox',
      name: '櫻井さん',
      texts: [
        'まさに柔軟性は重視した点でしたね。私たちはこれまで「KRAシステム」と呼ばれる自動車リサイクル総合管理ネットワークシステムを開発してきた経験から「ガチガチに仕様を固めて融通の利かないシステムを作るよりも、不完全でも動くシステムを改修しながら鍛え上げていくこと」を重視しており、その実現には柔軟性がなければいけないことを知っていたからです。というのも、私たちの業界のECサイトなどのシステム作りはほぼ100%と言っていいほど失敗するものなんですよ。',
        'それは決してSIerさんたちがこの業界を甘く見ているわけではなく、想像以上に属人的な世界であり、それをシステム化するというのはそれほどまでに難しいことだからです。中古車販売ならともかく、中古車から取れる数万点の部品をコンテナに詰めて売るというECサイトはどこにもないですからね。本当に難しいプロジェクトだったと思います。',
      ],
    },
  ],
  [
    {
      type: 'sectionTitle',
      text: '前例のない高難易度プロジェクト。大切なのはやはりコミュニケーションだった',
    },
    {
      type: 'imageWithCaption',
      src: '/images/img/cases/kaiho/interview2.webp',
      alt: 'インタビュー写真',
    },
    {
      type: 'textBox',
      texts: ['―― 実際にプロジェクトを進行して、Aitriaの印象はいかがでしたか？'],
      wide: false,
      bold: true,
    },
    {
      type: 'greyBox',
      name: '鈴木さん',
      texts: [
        '最初から懇切丁寧にヒアリングしていただき、本当に深いところまで私たちのビジネスを理解してから要件定義に落とし込んでもらえたので、非常にありがたかったです。',
      ],
    },
    {
      type: 'greyBox',
      name: '朝倉さん',
      texts: [
        'とてもスムーズに進めることができたという印象があります。弊社の「こうしたい」というおおまかな要望を、具体的に言語化・課題化してくださったので、私たちもそれに基づいて動くことができ、良い流れが作れたのが大きかったと思います。',
      ],
    },
    {
      type: 'greyBox',
      name: '鈴木さん',
      texts: [
        '今回のプロジェクトは、単純に「既存業務をシステム化するECサイト」を作るのではなく、我々の業務自体を変えてシステムもそれと同時に変更する「本当の意味でのDX」でした。ですので、最初の要件定義は私自身でもなかなか決められないポイントも多かったので、Aitriaさんの存在はとても助かりましたね。',
        'もちろん、それでも開発を進めていざ導入してみると「もっとこうした方が良かった」という点は出てくるのですが、そこもAitriaさんには臨機応変に対応していただけて、ありがたかったです。実際のシステム導入の段階では、野田さんに弊社に常駐するかたちで出張していただいたのですが、そこもスムーズに進行できた一因になったと思います。',
      ],
    },
    {
      type: 'greyBox',
      name: '芝',
      texts: [
        'やはり開発終盤の細かな修正の出し戻しには、リモートでの対応では限界がある場合が多いんですよね。データ上で対応項目に優先順位をつけてもらったとしても「なぜこの修正が必要なのか」などが分からない場合があるからです。',
      ],
    },
    {
      type: 'greyBox',
      name: '野田',
      texts: [
        '私としても今回の出張は大きな経験でした。実際にみなさんと同じ事務室で作業させていただいたのですが、オフィスのすぐ横で自動車を解体していることに驚かされました。そういった各部署の密接なつながりを含む社風はリモートではなかなか伝わってこないため、よりお客さんのビジネスを理解できましたし、今後の進行にも繋げられると感じています。',
      ],
    },
    {
      type: 'imageWithCaption',
      src: '/images/img/cases/kaiho/interview3.webp',
      alt: 'インタビュー写真',
      text: 'Aitria エンジニア 野田 真理菜',
    },
    {
      type: 'textBox',
      texts: ['―― 今回のプロジェクトで困難だったポイントはありますか？'],
      wide: false,
      bold: true,
    },
    {
      type: 'greyBox',
      name: '鈴木さん',
      texts: [
        '今回は前例がないシステム開発であり、開発前にモックを作って検証するほどのスケジュールも予算もなかったため、要件定義の段階で問題がないように見えても、実際に操作してみたら「全然違う」となってしまう部分はどうしても出てきてしまいました。',
        'そのため、リリースした後は喧々諤々とお話しさせていただくことが何度もありました。ですが、逆にそこまで深くお付き合いいただけたことに非常に感謝しています。',
      ],
    },
    {
      type: 'greyBox',
      name: '櫻井さん',
      texts: [
        '私としても、腹を割ってお話しできたのは本当に良かったと思っています。要件定義の段階から両者で意見が分かれていた部分はあったのですが、私たちが求めているのは仕事を発注する側と受注する側の関係ではなく、一緒に同じ方向を向いて走るパートナーですので、それはポジティブに議論を戦わせて一緒にシステムを作り上げていけた証拠だったと思っています。',
        'まだまだ100％の出来ではないですが、結局はシステムって開発が終わるものではなく、できるところから走らせていくものなので、最終的にはやはり信頼関係がすべてだと思いますね。',
      ],
    },
    {
      type: 'greyBox',
      name: '芝',
      texts: [
        '意見の相違などはありましたが、会宝産業さんはシステム開発の知見も豊富で非常に高いレベルで議論ができたことからも、プロジェクトとして良い結果に繋げることができたと思います。弊社としては「ただ成果物を納品するのではなく、お客さんのビジネスに貢献する」という目的を常に持って行動するように心がけていますので、野田がそれをしっかりと理解して実行できていたのが良かったとも思っています。',
      ],
    },
  ],
  [
    {
      type: 'sectionTitle',
      text: '好評のグローバルECサイトを通して、世界のプラットフォーマーへ',
    },
    {
      type: 'imageWithCaption',
      src: '/images/img/cases/kaiho/interview4.webp',
      alt: 'インタビュー写真',
    },
    {
      type: 'textBox',
      texts: ['―― グローバルECサイトをリリースして効果や反響はいかがですか？'],
      wide: false,
      bold: true,
    },
    {
      type: 'greyBox',
      name: '鈴木さん',
      texts: [
        '弊社では売上の指標として「車1台あたりの部品販売点数」と「1台当たりの売上」を持っているのですが、グローバルECサイト導入後では約130％に上昇している結果が出ており、当社の売り上げ向上に非常に上手くつながっているという結果が出ています。そしてこの売り上げにはまだまだ伸び代はあると思っておりますので、野田さんをはじめとしたAitriaの皆さんと今も一緒に改善に取り組んでいるところです。',
        'ローンチ当初は、既存のお客さんからは「電話したほうが早い」とか「メールしたほうが早い」という不評の声が大きかったのですが、すぐに利便性に気づかれたようでした。お客さんも代替わりして若くなってきている影響もあると思いますが、最初は嫌がっていた人も、在庫連携の時刻を待ち構えて一度にたくさん注文してくるようになりました。弊社は前金以上の注文は受け付けないようにしているのですが、グローバルECサイトを導入してからは前金を上回って注文してくる人もいてロックをかけるのが大変なくらいです（笑）。',
      ],
    },
    {
      type: 'textBox',
      texts: ['―― 今後のグローバルECサイト、そして会宝産業さんの展望について伺えますか？'],
      wide: false,
      bold: true,
    },
    {
      type: 'greyBox',
      name: '櫻井さん',
      texts: [
        'グローバルECサイトは現在当社だけの在庫でやり取りしていますが、会宝産業のアライアンスメンバー様の在庫も扱えるようにしていく予定です。「ここを見れば日本国内にある中古車パーツをすべて調達できる」と思っていただける、そんなサイトにしていきたいですね。国内と海外という垣根がなくなってきている今、魅力的な商品の情報を掲載すればそれがどんどん売れていくことが分かってきたので、私たちはこのECサイトを通して、プラットフォーマーになりたいと考えています。',
      ],
    },
    {
      type: 'greyBox',
      name: '鈴木さん',
      texts: [
        'さらに大きな目標として、我々は自動車部品に限らず、日本にあるすべてのものを海外に発信して届けたいと思っています。実際に私たちはインドやUAEなど、海外の拠点をどんどん作っていく予定ですので、そこでもこのECサイトと同じようなものを立ち上げ、ワールドワイドな流通ネットワークを作り上げていきたいです。そのためにも、このECサイトのUX/UIをより高められるよう、KRAシステムと合わせた改善を重ねていきたいです。',
      ],
    },
    {
      type: 'greyBox',
      name: '朝倉さん',
      texts: [
        'ECサイト改善にあたっては、使っていただいたお客さまからの声が最高の改善材料になると感じています。売り上げなどの数字ももちろん大切ですが、お客さんに「使いやすい」と喜んでいただき、継続的に使っていただくことがいちばんの原動力になっています。そのため、そうしたお客さまの声をしっかり汲み取って、Aitriaさんと一緒により良いサイトにしていきたいと思っています。',
      ],
    },
  ],
]

const sectionTitle: { title: string; sub_title: string } = {
  title: 'Interview',
  sub_title: 'インタビュー',
}

const tweenVars: gsap.TimelineVars = {
  y: 50,
  duration: 1,
  opacity: 0,
  ease: Power4.easeOut,
}

const Interview: React.FC = () => {
  const timeline = gsap.timeline()
  const wrapper = useRef<HTMLElement>()
  const image = useRef<HTMLImageElement>()
  const text_container = useRef<HTMLDivElement>()
  // const container = useRef<HTMLDivElement>()

  useEffect(() => {
    timeline.from(image.current, tweenVars, 0.2)
    timeline.from(text_container.current, tweenVars, 0.4)

    ScrollTrigger.create({
      animation: timeline,
      trigger: wrapper.current,
      start: 'top-=100 80%',
      toggleActions: 'play none none reverse',
    })
  }, [])

  return (
    <section className={styles.wrapper} ref={wrapper}>
      <div className={styles.content}>
        <TitleFlex sectionTitle={sectionTitle} />
        <div className={styles.article_container} ref={text_container}>
          <InterviewContents contentData={contentData} />
        </div>
      </div>
    </section>
  )
}

export default Interview
